
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface GdprSettings {
  gdpr_enabled: boolean;
  consent_banner_text: string;
  privacy_policy_url: string;
  cookie_policy_url: string;
  consent_mode_enabled: boolean;
  data_retention_days: number;
  consent_categories: Record<string, any>;
}

export const useGdprSettings = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['gdpr-settings'],
    queryFn: async (): Promise<GdprSettings> => {
      const { data, error } = await supabase
        .from('gdpr_settings')
        .select('key, value');
      
      if (error) throw error;
      
      const settings = (data || []).reduce((acc: Record<string, any>, setting) => {
        acc[setting.key] = setting.value;
        return acc;
      }, {});

      return {
        gdpr_enabled: settings.gdpr_enabled || false,
        consent_banner_text: settings.consent_banner_text || 'We use cookies to enhance your experience.',
        privacy_policy_url: settings.privacy_policy_url || '/privacy',
        cookie_policy_url: settings.cookie_policy_url || '/cookies',
        consent_mode_enabled: settings.consent_mode_enabled || false,
        data_retention_days: settings.data_retention_days || 730,
        consent_categories: typeof settings.consent_categories === 'string' 
          ? JSON.parse(settings.consent_categories) 
          : settings.consent_categories || {},
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  return {
    gdprSettings: data,
    isLoading,
    error
  };
};
